module.exports = "<span\n  *ngIf=\"buildInfo\"\n  class=\"mat-caption\"\n  matTooltip=\"{{buildInfo.buildTime | date}}\">\n  <strong>server:</strong> {{buildInfo.buildVersion}}\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/backend-version/backend-version.component.html
// module id = ./src/app/shared/components/backend-version/backend-version.component.html
// module chunks = main